import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { flashMessage as flash } from "./../../../utils/flash/index";
import claimService from "./claimService";
import policyService from "../policy/policyService";

const initialState = {
  policyHolder: null,
  category_policy: null,
  single_claim_settings: null,
  claims: null,
  claim_comments: null,
  claim_settings: [],
  savings_claim_settings: [],
  claim_process_settings: null,
  tempCoverInfo: null,
  isLoading: false,
  categoryLoading: false,
  isSuccess: false,
  createSuccess: false,
  updateSuccess: false,
  isUpdating: false,
  isFiltering: false,
  isSearching: false,
  isError: false,
  approveSuccess: false,
  declineSuccess: false,
};

const claimSlice = createSlice({
  initialState,
  name: "claim",
  reducers: {
    resetClaim: (state) => initialState,
    resetSingleClaim: (state) => {
      state.single_claim_settings = null;
    },
    resetClaimStatus: (state) => {
      state.isError = false;
      state.isSuccess = false;
      state.isLoading = false;
      state.single_cover = null;
      state.createSuccess = false;
      state.updateSuccess = false;
      state.isUpdated = false;
      state.isFetching = false;
      state.isFiltering = false;
      state.isSearching = false;
    },
    setTempCoverInfo: (state, { payload }) => {
      state.tempCoverInfo = payload;
    },
    resetTempCoverInfo: (state) => {
      state.tempCoverInfo = null;
    },
    resetUpdateSuccess: (state) => {
      state.updateSuccess = false;
      state.approveSuccess = false;
      state.declineSuccess = false;
    },
    resetSingleClaims: (state) => {
      state.single_claim = null;
    },
    resetPolicyHolder: (state) => {
      state.policyHolder = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPolicyHolder.pending, (state) => {
        state.isLoading = true;
        state.policyHolder = null;
        flash("info", "Fetching policy holder information...");
      })
      .addCase(getPolicyHolder.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (!payload.errors) {
          flash("success", "Information fetched successfully...");
          state.policyHolder = payload;
        } else if (typeof payload.errors == "string") {
          flash("error", payload.errors);
        } else {
          let key = Object.keys(payload.errors)[0];
          let message = payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(getPolicyHolder.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(getCategoryPolicy.pending, (state) => {
        state.categoryLoading = true;
      })
      .addCase(getCategoryPolicy.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (!payload.errors) {
          state.category_policy = payload.policy;
        } else if (typeof payload.errors == "string") {
          flash("error", payload.errors);
        } else {
          let key = Object.keys(payload.errors)[0];
          let message = payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(getCategoryPolicy.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(getAllClaimSettings.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllClaimSettings.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (!payload.errors) {
          state.claim_settings = payload.claim_settings;
          state.savings_claim_settings = payload.savings_claim_settings;
        } else if (typeof payload.errors == "string") {
          flash("error", payload.errors);
        } else {
          let key = Object.keys(payload.errors)[0];
          let message = payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(getAllClaimSettings.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(getSingleSettings.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getSingleSettings.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (!payload.errors) {
          state.single_claim_settings = payload.get_claim_setting;
        } else if (typeof payload.errors == "string") {
          flash("error", payload.errors);
        } else {
          let key = Object.keys(payload.errors)[0];
          let message = payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(getSingleSettings.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(createClaimSettings.pending, (state) => {
        state.isLoading = true;
        flash("info", "Claims Configuration is Creating");
      })
      .addCase(createClaimSettings.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (!payload.errors) {
          state.createSuccess = true;
          flash("success", payload.message);
        } else if (typeof payload.errors == "string") {
          flash("error", payload.errors);
        } else {
          let key = Object.keys(payload.errors)[0];
          let message = payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(createClaimSettings.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(getClaimProcessSettings.pending, (state) => {
        state.isLoading = true;
        // flash("info", "Initializing process...");
      })
      .addCase(getClaimProcessSettings.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (!payload.errors) {
          state.claim_process_settings = payload;
        } else if (typeof payload.errors == "string") {
          flash("error", payload.errors);
        } else {
          let key = Object.keys(payload.errors)[0];
          let message = payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(getClaimProcessSettings.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(createClaim.pending, (state) => {
        state.isLoading = true;
        flash("info", "Initiating claim process...");
      })
      .addCase(createClaim.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (!payload.errors) {
          state.createSuccess = true;
          state.claim_process_settings = payload;
          flash("success", payload.message);
        } else if (typeof payload.errors == "string") {
          flash("error", payload.errors);
        } else {
          let key = Object.keys(payload.errors)[0];
          let message = payload.errors[key][0] || payload.message;
          flash("error", message);
        }
      })
      .addCase(createClaim.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(getCover.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCover.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (!payload.errors) {
          state.policy_cover = payload;
        }
      })
      .addCase(getCover.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(getClaims.pending, (state) => {
        state.isLoading = true;
        state.isFiltering = true;
        state.isSuccess = false;
      })
      .addCase(getClaims.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isFiltering = false;
        state.isFiltered = false;
        if (!payload.errors) {
          state.isSuccess = true;
          state.claims = payload;
        } else if (typeof payload.errors == "string") {
          flash("error", payload.errors);
        } else {
          let key = Object.keys(payload.errors)[0];
          let message = payload.errors[key][0] || payload.message;
          flash("error", message);
        }
      })
      .addCase(getClaims.rejected, (state, action) => {
        state.isLoading = false;
        state.isFiltering = false;
        state.isError = true;
      })
      .addCase(getSingleClaim.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getSingleClaim.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (!payload.errors) {
          state.single_claim = payload;
        }
      })
      .addCase(getSingleClaim.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(updateClaimSettings.pending, (state) => {
        state.isLoading = true;
        flash("info", "Claims Configuration is Updating");
      })
      .addCase(updateClaimSettings.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (!payload.errors) {
          state.updateSuccess = true;
          flash("success", payload.message);
        } else if (typeof payload.errors == "string") {
          flash("error", payload.errors);
        } else {
          let key = Object.keys(payload.errors)[0];
          let message = payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(updateClaimSettings.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(declineClaim.pending, (state) => {
        state.isLoading = true;
        flash("info", "Processing decline...");
      })
      .addCase(declineClaim.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (!payload.errors) {
          state.declineSuccess = true;
          flash("success", payload.message);
        } else if (typeof payload.errors == "string") {
          flash("error", payload.errors);
        } else {
          let key = Object.keys(payload.errors)[0];
          let message = payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(declineClaim.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(approveClaim.pending, (state) => {
        state.isLoading = true;
        flash("info", "Processing approval...");
      })
      .addCase(approveClaim.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (!payload.errors) {
          state.approveSuccess = true;
          flash("success", payload.message);
        } else if (typeof payload.errors == "string") {
          flash("error", payload.errors);
        } else {
          let key = Object.keys(payload.errors)[0];
          let message = payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(approveClaim.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(updateClaim.pending, (state) => {
        state.isLoading = true;
        flash("info", "Updating claim...");
      })
      .addCase(updateClaim.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (!payload.errors) {
          state.isUpdated = true;
          flash("success", payload.message);
        } else if (typeof payload.errors == "string") {
          flash("error", payload.errors);
        } else {
          let key = Object.keys(payload.errors)[0];
          let message = payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(updateClaim.rejected, (state) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(getClaimComments.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getClaimComments.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (!payload.errors) {
          state.claim_comments = payload.claim_comments;
          flash("success", payload.message);
        } else if (typeof payload.errors == "string") {
          flash("error", payload.errors);
        } else {
          let key = Object.keys(payload.errors)[0];
          let message = payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(getClaimComments.rejected, (state) => {
        state.isLoading = false;
        state.isError = true;
      }) // get all filtered applied policies
      .addCase(FilteredGeneralPolicyClaims.pending, (state) => {
        state.isLoading = true;
        state.isFiltering = true;
        state.isSuccess = false;
        flash("loading", "Filtering data...");
      })
      .addCase(FilteredGeneralPolicyClaims.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isFiltered = true;
        state.isFiltering = false;
        state.claims = payload;
        if (payload.errors) {
          flash("error", payload.errors);
        } else {
          flash("success", "Filtered successfully");
        }
      })
      .addCase(FilteredGeneralPolicyClaims.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isFiltering = false;
        state.message = action.payload;
        flash("error", action.payload);
      });
  },
});

export const declineClaim = createAsyncThunk(
  "/claim/declineClaim",
  async (data, thunkAPI) => {
    try {
      return await claimService.declineClaim(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const approveClaim = createAsyncThunk(
  "/claim/approveClaim",
  async (data, thunkAPI) => {
    try {
      return await claimService.approveClaim(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getPolicyHolder = createAsyncThunk(
  "/claim/getPolicyHolder",
  async (data, thunkAPI) => {
    try {
      return await claimService.getPolicyHolder(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getCategoryPolicy = createAsyncThunk(
  "/claim/getCategoryPolicy",
  async (data, thunkAPI) => {
    try {
      return await claimService.getCategoryPolicy(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getAllClaimSettings = createAsyncThunk(
  "/claim/getAllClaimSettings",
  async (data, thunkAPI) => {
    try {
      return await claimService.getAllClaimSettings(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getSingleSettings = createAsyncThunk(
  "/claim/getSingleSettings",
  async (id, thunkAPI) => {
    try {
      return await claimService.getSingleSettings(id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const updateClaimSettings = createAsyncThunk(
  "/claim/updateClaimSettings",
  async (data, thunkAPI) => {
    try {
      return await claimService.updateClaimSettings(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const createClaimSettings = createAsyncThunk(
  "/claim/createClaimSettings",
  async (data, thunkAPI) => {
    try {
      return await claimService.createClaimSettings(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getCover = createAsyncThunk(
  "/claim/getCover",
  async (ID, thunkAPI) => {
    try {
      return await policyService.getSinglePolicyCover(ID);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getClaimProcessSettings = createAsyncThunk(
  "/claim/getClaimProcessSettings",
  async (data, thunkAPI) => {
    try {
      return await claimService.getClaimProcessSettings(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const createClaim = createAsyncThunk(
  "/claim/createClaim",
  async (data, thunkAPI) => {
    try {
      return await claimService.createClaim(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getClaims = createAsyncThunk(
  "/claim/getClaims",
  async (data, thunkAPI) => {
    try {
      return await claimService.getClaims(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getSingleClaim = createAsyncThunk(
  "/claim/getSingleClaim",
  async (claims_id, thunkAPI) => {
    try {
      return await claimService.getSingleClaim(claims_id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const updateClaim = createAsyncThunk(
  "/claim/updateClaim",
  async (data, thunkAPI) => {
    try {
      return await claimService.updateClaim(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getClaimComments = createAsyncThunk(
  "/claim/getClaimComments",
  async (data, thunkAPI) => {
    try {
      return await claimService.getClaimComments(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const FilteredGeneralPolicyClaims = createAsyncThunk(
  "/claim/FilteredGeneralPolicyClaims",
  async (data, thunkAPI) => {
    try {
      return await claimService.FilteredGeneralPolicyClaims(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const {
  resetClaim,
  resetClaimStatus,
  resetSingleClaim,
  resetUpdateSuccess,
  setTempCoverInfo,
  resetSingleClaims,
  resetPolicyHolder,
} = claimSlice.actions;
export default claimSlice.reducer;
